var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_9405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.57366 2.01562L5.84111 3.125H11.4316L10.6991 2.01562C10.6412 1.92969 10.5448 1.875 10.4407 1.875H6.82813C6.72403 1.875 6.62764 1.92578 6.56981 2.01562H6.57366ZM12.2413 0.976562L13.6563 3.125H14.1883H16.039H16.3474C16.8602 3.125 17.2727 3.54297 17.2727 4.0625C17.2727 4.58203 16.8602 5 16.3474 5H16.039V16.875C16.039 18.6016 14.6587 20 12.9545 20H4.31818C2.61404 20 1.23377 18.6016 1.23377 16.875V5H0.925325C0.412541 5 0 4.58203 0 4.0625C0 3.54297 0.412541 3.125 0.925325 3.125H1.23377H3.08442H3.61648L5.03145 0.972656C5.43243 0.367188 6.10714 0 6.82813 0H10.4407C11.1617 0 11.8364 0.367188 12.2374 0.972656L12.2413 0.976562ZM3.08442 5V16.875C3.08442 17.5664 3.63576 18.125 4.31818 18.125H12.9545C13.637 18.125 14.1883 17.5664 14.1883 16.875V5H3.08442ZM6.16883 7.5V15.625C6.16883 15.9688 5.89123 16.25 5.55195 16.25C5.21266 16.25 4.93507 15.9688 4.93507 15.625V7.5C4.93507 7.15625 5.21266 6.875 5.55195 6.875C5.89123 6.875 6.16883 7.15625 6.16883 7.5ZM9.25325 7.5V15.625C9.25325 15.9688 8.97565 16.25 8.63636 16.25C8.29708 16.25 8.01948 15.9688 8.01948 15.625V7.5C8.01948 7.15625 8.29708 6.875 8.63636 6.875C8.97565 6.875 9.25325 7.15625 9.25325 7.5ZM12.3377 7.5V15.625C12.3377 15.9688 12.0601 16.25 11.7208 16.25C11.3815 16.25 11.1039 15.9688 11.1039 15.625V7.5C11.1039 7.15625 11.3815 6.875 11.7208 6.875C12.0601 6.875 12.3377 7.15625 12.3377 7.5Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_9405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2727,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.00886bc4555edc711c94e603f21f3716.svg";
export { ForwardRef as ReactComponent };